import sanitizeHtml from 'sanitize-html';

export const getCleanHtml = (
  html?: string,
  allowedTags = ['p', 'b', 'strong', 'a', 'br', 'i', 'em'],
  allowedAttributes = {
    img: ['href', 'src', 'alt'],
    a: ['href', 'target', 'rel'],
  }
) => {
  if (!html) return '';
  // Sanitize message body HTML
  let sanitizedHtml = sanitizeHtml(html, {
    allowedTags,
    allowedAttributes,
  });

  // remove non-breaking spaces and empty p tags to maintain formatting
  sanitizedHtml = sanitizedHtml.replace(/<p>&nbsp;<\/p>/, '');
  sanitizedHtml = sanitizedHtml.replace(/<p[^>]*><\/p[^>]*>/, '');
  sanitizedHtml = sanitizedHtml.replace(/<p[^>]*>.<\/p[^>]*>/, '');
  sanitizedHtml = sanitizedHtml.trim();

  return sanitizedHtml;
};
